export default __webpack_public_path__ + "static/media/blend-table.bf188806.svg";